import { Users } from '@.pages';
import { User } from '@/Components/Pages/Settings/Users/User';
import { UserCreatePage } from '@/Components/Pages/Settings/Users/UserCreatePage';
import { UserEditPage } from '@/Components/Pages/Settings/Users/UserEditPage';

import { RoutePage } from '../types';

export const UsersPage: RoutePage = {
    url: 'users',
    component: <Users />,
    permissions: {
        entity: 'Users',
        right: 'read',
    },
    sidebar: {
        name: 'Users',
    },
    children: [
        {
            url: ':id',
            component: <User />,
            children: [
                {
                    url: 'edit',
                    component: <UserEditPage />,
                    permissions: {
                        entity: 'Users',
                        right: 'update',
                    },
                },
            ],
        },
        {
            url: 'add',
            component: <UserCreatePage />,
            permissions: {
                entity: 'Users',
                right: 'create',
            },
        },
    ],
};
